"use strict";

var startCase = require('lodash/startCase');

var isArray = require('lodash/isArray');

var _require = require('../../../../products/components'),
    EuroFlapEnvelopeLiner = _require.EuroFlapEnvelopeLiner;

function getLinerColorText(liner_color) {
  var text = '';

  if (liner_color && isArray(liner_color)) {
    text = liner_color && liner_color.join('');
  } else if (liner_color) {
    text = liner_color;
  }

  text = text.replace(' ', '');
  return text;
}

module.exports = function (accumulator, order, product, component) {
  var addition;
  var formatted_liner_pattern = startCase(component.liner_pattern).replace('Watercolor', 'WC').replace(/\s/g, '');

  if (component.FLORAL_LINERS.includes(component.liner_pattern)) {
    addition = "Floral-Liner-".concat(formatted_liner_pattern);

    if (component instanceof EuroFlapEnvelopeLiner) {
      addition += '-Euro';
    }
  } else {
    addition = "Liner-".concat(formatted_liner_pattern);

    if (component instanceof EuroFlapEnvelopeLiner) {
      addition += '-Euro';
    }

    var liner_color_text = getLinerColorText(component.liner_color);
    addition += "-".concat(liner_color_text);
  }

  return accumulator + '-' + addition;
};